export default __webpack_public_path__ + "static/media/project3-p1.d7bfb772.png";